import { render } from "./XIconSolidListBullets.vue?vue&type=template&id=3f2b74e1"
import script from "./XIconSolidListBullets.vue?vue&type=script&lang=js"
export * from "./XIconSolidListBullets.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidListBullets.vue"]])

export default __exports__